﻿import m from "mithril";
import i18n from "../../../shared/i18n/i18n";
import Component_Unit_Approval_Settings from "./component_unit_approval_settings";

let loading = false;
let tab = "settings";
let unit = null;

const Page_Unit_Approval = {
    oninit: function (vnode) {
        unit = vnode.attrs.unit;
    },
    view: function () {
        return [
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section with-menu", [
                        m("h1", i18n.t("approval_unit")),
                        m(".toolbar-menu", [
                            m("div", {class: tab === "settings" ? "active" : ""}, i18n.t("settings"))
                        ])
                    ])
                ])
            ]),
            !loading ? [
                unit ? [
                    m(Component_Unit_Approval_Settings, {unit: unit.properties})
                ] : m(".text-gray padding", "Unable to load unit")
            ] : m(".text-gray padding", [i18n.t("loading"), m(".loading-dots")])
        ];
    }
};
export default Page_Unit_Approval;
